import React, { useState, useEffect } from "react";
import "../../style/Body/Cobrar.css";
import { BsTelephone, BsCheckCircle, BsXCircle } from "react-icons/bs";
import { APIfetchApi } from "../../utils/APIfetchApi";
import Select from "react-select";
import { useAppContext } from "../../AppContext";

export default function Cobrar() {
  const { globalState, setGlobalState } = useAppContext({});
  const [operadores, setOperadores] = useState([]);

  const ENDPOINT = process.env.REACT_APP_URL_BASE_NEW;

  const TOKEN = process.env.REACT_APP_TOKEN;
  const APIKEY = process.env.REACT_APP_NEW_APIKEY;

  const fetchApi = new APIfetchApi();
  let headerConsulta = new Headers();
  headerConsulta.append("Access-Control-Allow-Origin", "*");
  headerConsulta.append("Access-Control-Allow-Headers", "*");
  headerConsulta.append("Content-Type", "application/json");
  headerConsulta.append("api-key", APIKEY);
  const handleInit = async () => {
    if(globalState.whatsapp){
    const consultStatus = await fetchApi.fetchApi(
      headerConsulta,
      "GET",
      undefined,
      ENDPOINT + "/companies?amount=" + globalState.amount
    );
    const info = await consultStatus.json();
    if (consultStatus.status === 200) {
      let arr = info.data;
      arr.push({company:"Otro"});
      setOperadores(info.data);
    } else {
      setOperadores([]);
    }
  }
  };

  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isModified, setIsModified] = useState(false);

  const handleChange = (event) => {
    const inputPhoneNumber = event.target.value;

    if (inputPhoneNumber.length < 11) {
      setPhoneNumber(inputPhoneNumber);
      setGlobalState({
        ...globalState,
        phoneNumber: event.target.value,
        disabledCobrar: isValidPhoneNumber,
      });
      setIsModified(true);
    }
  };

  const isValidPhoneNumber =
    phoneNumber.length === 10 && /^\d+$/.test(phoneNumber);

  const handleSelect = (e) => {
    setSelectedOption(e);
    const selectedOperatorInfo = operadores.find(
      (operator) => operator.company === e.value
    );
    setGlobalState({
      ...globalState,
      company: selectedOperatorInfo.company,
    });
  };

  const options = [];

  operadores.map(function (operador) {
    return options.push({ label: operador.company, value: operador.company });
  });

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const colourStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: 10,
      zIndex: 1000,
      background: "rgb(49, 51, 72)",
      color: "#FFFFFF",
      // match with the menu
    }),
    menuList: (styles) => ({
      ...styles,
      background: "rgb(49, 51, 72)",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#FFFFFF",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "rgb(49, 51, 72)"
        : isSelected
        ? "hsla(241, 21%, 30%, 1)"
        : undefined,
      zIndex: 1,
    }),
    menu: (base) => ({
      ...base,
      color: "#FFFFFF",
      zIndex: 100,
    }),
  };

  return (
    <>
      <div className="recuadro-cobrar ">
        {globalState.whatsapp && (
          <>
            <h2 className="title-cobrar">Confirma tus datos</h2>
            <p className="text-cobrar">Selecciona tu operador</p>
            <div className="divider-cobrar">
              {operadores.length === 0 ? null : (
                <Select
                  styles={colourStyles}
                  placeholder="Selecciona tu operador"
                  className="select-cobrar"
                  value={selectedOption}
                  onChange={handleSelect}
                  options={options}
                />
              )}
            </div>{" "}
          </>
        )}
        {globalState.whatsapp ? (
          <p className="text-cobrar">Número para recargar:</p>
        ) : (
          <>
            {" "}
            <h1 className="text-cobrar">
              Si deseas participar en futuras encuestas ingresa tu número
            </h1>{" "}
            <br /> <p className="text-cobrar">Número de celular:</p>
          </>
        )}

        <div
          className={`input-cobrar ${
            isModified && (isValidPhoneNumber ? "valid" : "invalid")
          }`}
        >
          <span
            className={`input-icon-cobrar ${
              isModified && (isValidPhoneNumber ? "valid" : "invalid")
            }`}
          >
            <BsTelephone />
          </span>
          <input
            type="number"
            className="input-celular-cobrar"
            placeholder="Número celular"
            onChange={handleChange}
            value={phoneNumber}
          />
          {isModified && (
            <span
              className={`input-icon-check-cobrar ${
                isModified && (isValidPhoneNumber ? "valid" : "invalid")
              }`}
            >
              {isValidPhoneNumber ? <BsCheckCircle /> : <BsXCircle />}
            </span>
          )}
        </div>
        {globalState.whatsapp && (
          <>
            <p className="text-cobrar-large">Detalles de la recarga</p>{" "}
            <p className="text-cobrar">
              Se hará una recarga de <strong>${globalState.amount}.00</strong> a
              la compañía y número seleccionado
            </p>
          </>
        )}
      </div>
    </>
  );
}
